export enum RequestStepType {
  PreviousStep = -1,
  SaveOnly = 0,
  NextStep = 1,
}
